import { Select } from 'antd';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  &.ant-select-item {
    line-height: 32px !important;
  }
`;
